<template>
    <div class="curriculum content">
        <div class="curr_btn">
            <div class="course_div">
                <span :class="courseTitle?'bgImgSet':'courseName'" @click='back' style="cursor: pointer;">课程列表</span>
                <span v-if="courseTitle" class="course">/</span>
                <span class="courseTi">{{courseTitle}}</span>
            </div>
            <Button v-if="$route.query.courseStatus == 2" type="primary" @click="addSection()">添加章节</Button>
            <!--<Button type="warning" @click="addSort()" style="float: right">排序</Button>-->
        </div>
        <div class="curr_tab">
            <Table :loading="loading" border ref="selection" :columns="columns" :data="sectionList"></Table>
            <div>
                <page-component
                    class="page"
                    :total-num="totalNum"
                    :page-num="pageNum"
                    v-on:changePage="changePage"
                    v-on:changePageSize="changePageSize"
                    v-on:clickPage="clickPage"
                ></page-component>
            </div>
        </div>
    </div>
</template>
<style scoped>
.curriculum > div {
    padding: 10px 0;
}

.course_div {
    margin-bottom: 10px;
}

.courseName {
    color: #000;
    font-size: 14px;
}

.bgImgSet {
    color: #666;
    font-size: 14px;
}

.course {
    margin-left: 6px;
    color: #ccc;
    font-size: 14px;
}

.courseTi {
    margin-left: 6px;
    font-size: 13px;
    color: #000;
}

.page {
    margin-top: 20px;
}
</style>
<script>
import http from "../../libs/http.js";
import pageComponent from "../common/page.vue";
import { mapGetters } from "vuex";
export default {
    data() {
        return {
            loading: false,
            courseId: this.$route.query.courseId,
            courseTitle: this.$route.query.courseTitle,
            columns: [
                {
                    title: "No.",
                    key: "seq",
                    width: 60
                },
                {
                    title: "课节名称",
                    key: "sectionName"
                },
                {
                    title: "单元主题",
                    key: "unitId",
                    render: (h, params) => {
                        return h(
                            "span",
                            params.row.unitId
                                ? this.changeUnitName(params.row.unitId).eName
                                : ""
                        );
                    }
                },
                //                {
                //                    title: '星星数',
                //                    key: 'starCount',
                //                },

                {
                    title: "类型",
                    key: "sectionType",
                    render: (h, params) => {
                        switch (params.row.sectionType) {
                            case 1:
                                return h("span", "学习");
                            case 2:
                                return h("span", "复习");
                            case 6:
                                return h("span", "自拼课");
                            case 8:
                                return h("span", "双周复习");
                            case 7:
                                return h("span", "周复习");
                            case 10:
                                return h("span", "月复习");
                            case 100:
                                return h("span", "总复习");
                            case 99:
                                return h("span", "测评课");
                            case 1001:
                                return h("span", "1-新增");
                            case 1002:
                                return h("span", "2-新增");
                            case 1003:
                                return h("span", "3-新增");
                            case 2001:
                                return h("span", "1-新测评");
                            case 2002:
                                return h("span", "2-新测评");
                            case 2003:
                                return h("span", "3-新测评");
                        }
                    }
                },
                {
                    title: "单词",
                    key: "title"
                },
                {
                    title: "主题图",
                    key: "themeUrl",
                    align: "center",
                    width: 150,
                    render: (h, params) => {
                        return params.row.themeUrl
                            ? h("img", {
                                  attrs: {
                                      src: params.row.themeUrl
                                  },
                                  style: {
                                      height: "70px",
                                      marginTop: "5px"
                                  }
                              })
                            : h("span", "暂无图片");
                    }
                },
                // {
                //     title: '成绩单图',
                //     key: 'reportImage',
                //     align: 'center',
                //     width: 150,
                //     render: (h, params) => {
                //         return params.row.reportImage ? h('img', {
                //             attrs: {
                //                 src: params.row.reportImage
                //             },
                //             style: {
                //                 height: '70px',
                //                 marginTop: '5px'
                //             },
                //         }) : h('div', '暂无图片')
                //     }
                // },
                {
                    title: "状态",
                    key: "status",
                    align: "center",
                    width: 90,
                    render: (h, params) => {
                        return h("div", [
                            h(
                                "span",
                                {
                                    style: {
                                        color:
                                            params.row.status == 1
                                                ? "#19be6b"
                                                : "#ed4014"
                                    }
                                },
                                params.row.status == 1 ? "已上架" : "未上架"
                            )
                        ]);
                    }
                },
                {
                    title: "操作",
                    key: "action",
                    width: 300,
                    fixed: "right",
                    render: (h, params) => {
                        return h(
                            "div",
                            {
                                style: {
                                    height: "70px",
                                    paddingTop: "25px"
                                }
                            },
                            [
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type:
                                                params.row.status == 1
                                                    ? "error"
                                                    : "success",
                                            size: "small",
                                            disabled:
                                                this.$route.query
                                                    .courseStatus == 1
                                                    ? true
                                                    : this.getLimit == 1 ||
                                                      this.getLimit == 6
                                                    ? false
                                                    : true
                                        },
                                        style: {
                                            marginRight: "10px"
                                        },
                                        on: {
                                            click: () => {
                                                this.changeStatus(
                                                    params.row.sectionId,
                                                    params.row.status == 1
                                                        ? 2
                                                        : 1
                                                );
                                            }
                                        }
                                    },
                                    params.row.status == 1 ? "下架" : "上架"
                                ),
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "primary",
                                            size: "small",
                                            disabled:
                                                params.row.status == 1
                                                    ? this.getLimit == 1 ||
                                                      this.getLimit == 6
                                                        ? false
                                                        : true
                                                    : false
                                        },
                                        style: {
                                            marginRight: "10px"
                                        },
                                        on: {
                                            click: () => {
                                                this.addSection(params.row);
                                            }
                                        }
                                    },
                                    "编辑课节"
                                ),
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "error",
                                            size: "small",
                                            disabled:
                                                this.getLimit == 1 ||
                                                this.getLimit == 6
                                                    ? false
                                                    : true
                                        },
                                        style: {
                                            // marginTop: '3px',
                                            marginRight: "5px"
                                        },
                                        on: {
                                            click: () => {
                                                this.deleteSection(
                                                    params.row.sectionId
                                                );
                                            }
                                        }
                                    },
                                    "删除"
                                ),
                                h(
                                    "ButtonGroup",
                                    {
                                        style: {
                                            marginLeft: "20px"
                                        }
                                    },
                                    [
                                        h("Button", {
                                            props: {
                                                type: "info",
                                                size: "small",
                                                disabled:
                                                    this.$route.query
                                                        .courseStatus == 1
                                                        ? true
                                                        : false,
                                                icon: "ios-arrow-up",
                                                ghost: true
                                            },
                                            on: {
                                                click: () => {
                                                    this.move(params.row, 0);
                                                }
                                            }
                                        }),
                                        h("Button", {
                                            props: {
                                                type: "info",
                                                size: "small",
                                                disabled:
                                                    this.$route.query
                                                        .courseStatus == 1
                                                        ? true
                                                        : false,
                                                icon: "ios-arrow-down",
                                                ghost: true
                                            },
                                            style: {
                                                marginRight: "4px"
                                            },
                                            on: {
                                                click: () => {
                                                    this.move(params.row, 1);
                                                }
                                            }
                                        })
                                    ]
                                )
                                // h('Button', {
                                //     props: {
                                //         type: 'success',
                                //         size: 'small',
                                //         disabled: this.$route.query.courseStatus == 1 ? true : false
                                //     },
                                //     style: {
                                //         marginRight: '5px'
                                //     },
                                //     on: {
                                //         click: () => {
                                //             this.$router.push({ path: 'info', query: { sectionId: params.row.sectionId, courseId: this.courseId,courseTitle:this.courseTitle,sectionName: params.row.sectionName } })
                                //         }
                                //     }
                                // }, '章节详情'),
                            ]
                        );
                    }
                }
            ],
            sectionList: [],
            unitList: [],
            totalNum: 0,
            pageNum: 1,
            pageSize: 10
        };
    },

    created: function() {},
    // activated: function() {
    //     this.getUnit()
    // },
    methods: {
        back() {
            this.$router.go(-1);
        },
        //当前页数
        changePage(data) {
            this.pageNum = data;
            this.getSection(this.pageNum, this.pageSize);
        },
        //点击切换页数
        clickPage(data) {
            this.pageNum = data;
            this.getSection(this.pageNum, this.pageSize);
        },
        //当前每页显示的条数
        changePageSize(data) {
            this.pageSize = data;
            this.getSection(this.pageNum, this.pageSize);
        },
        changeUnitName(unitId) {
            for (var i = 0; i < this.unitList.length; i++) {
                if (unitId == this.unitList[i].id) {
                    return {
                        name: this.unitList[i].name,
                        level: this.unitList[i].level,
                        eName: this.unitList[i].eName
                    };
                }
            }
            return {
                name: "",
                level: "",
                eName: ""
            };
        },
        getUnit() {
            let that = this;
            that.loading = true;
            http.post("/custom/unitInfo/list", {
                status: 0
            }).then(res => {
                that.loading = false;
                let _list = [];
                _list = _list.concat(
                    res["list1"],
                    res["list2"],
                    res["list3"],
                    res["list4"]
                );
                that.unitList = _list;
                this.getSection(this.pageNum, this.pageSize);
            });
        },
        //获取sectionList表格
        getSection(num, pageSize) {
            let that = this;
            that.loading = true;
            http.post("/custom/section/list", {
                courseId: that.courseId,
                pageNum: num,
                pageSize: pageSize
            }).then(res => {
                if (num > res.pages && res.pages != 0) {
                    that.pageNum = res.pages;
                    that.getSection(res.pages, pageSize);
                } else {
                    that.loading = false;
                    that.sectionList = res.list;
                    that.totalNum = res.total;
                }
            });
        },
        //        //排序
        //        addSort() {
        //            let that = this;
        //            that.landing = true;
        //            http.post('/custom/section/sort', {
        //                courseId: that.courseId
        //            }).then(res => {
        //                that.getSection()
        //                that.landing = false;
        //            })
        //        },
        //添加
        addSection(row) {
            if (row) {
                this.$router.push({
                    path: "detail/editSection",
                    query: {
                        courseStatus: this.$route.query.courseStatus,
                        sectionId: row.sectionId,
                        courseId: this.courseId,
                        courseTitle: this.courseTitle,
                        sectionName: row.sectionName,
                        page: this.pageNum
                    }
                });
            } else {
                this.$router.push({
                    path: "addSection",
                    query: { courseId: this.courseId, page: this.pageNum }
                });
            }
        },
        deleteSection(sectionId) {
            let that = this;
            this.$Modal.confirm({
                title: "提示",
                content: "确定删除该章节?",
                onOk: () => {
                    http.post("/custom/section/del", {
                        courseId: that.courseId,
                        sectionId: sectionId
                    }).then(res => {
                        if (res) {
                            that.getSection(that.pageNum, that.pageSize);
                            that.$Message.success("删除成功");
                        }
                    });
                }
            });
        },
        // 移动
        move(row, type) {
            http.post("/custom/section/move", {
                seq: row.seq,
                id: row.sectionId,
                courseId: this.courseId,
                up: type
            }).then(res => {
                if (res) {
                    this.getSection(this.pageNum, this.pageSize);
                }
            });
        },
        // 上,下架
        changeStatus(sectionId, status) {
            let that = this;
            this.$Modal.confirm({
                title: "提示",
                content: "确定" + (status == 1 ? "上架" : "下架") + "该章节?",
                onOk: () => {
                    http.post("/custom/section/edit", {
                        courseId: this.courseId,
                        sectionId: sectionId,
                        status: status
                    }).then(res => {
                        if (res) {
                            this.getSection(this.pageNum, this.pageSize);
                            that.$Message.success(
                                status == 1 ? "上架成功" : "下架成功"
                            );
                        }
                    });
                }
            });
        },
        setPageNum(pageNum) {
            this.pageNum = Number(pageNum);
            this.getUnit();
        }
    },
    components: {
        pageComponent
    },
    // beforeRouteEnter(to, from, next) {
    //     if (from.path == "/gogo/addSection"||from.path == "/gogo/detail/editSection") {
    //         to.meta.keepAlive = true;
    //     }else{
    //         to.meta.keepAlive = false;
    //     }
    //     beforeRouteEnter (to, from, next) {
    //       next(vm => {
    //         // 通过 `vm` 访问组件实例
    //       })
    //     }
    // },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            if (
                from.path == "/gogo/addSection" ||
                from.path == "/gogo/detail/editSection" ||
                from.path == "/gogo/detail/step" ||
                from.path == "/gogo/detail/pf" ||
                from.path == "/gogo/detail/parentClass" ||
                from.path == "/gogo/detail/report" ||
                from.path == "/gogo/detail/signIn"
            ) {
                vm.setPageNum(from.query.page);
            } else {
                vm.setPageNum(1);
            }
            // 通过 `vm` 访问组件实例
        });
    },
    computed: {
        ...mapGetters(["getLimit"])
    }
};
</script>
